import type { MigrationStrategies } from 'rxdb';
import type { InspectionListDocument } from './inspectionList.types';

export const inspectionsListMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: InspectionListDocument) => ({ ...oldDoc, isAdhoc: false }),
};
